import { createFileRoute, notFound } from "@tanstack/react-router";
export const Route = createFileRoute("/_authed/portal/design-system")({ beforeLoad: () => { throw notFound(); } });